(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function init(form) {
      /* Stepper buttons adjust the sibling input, then submit so Shopify recalculates. */
      Array.prototype.slice.call(form.querySelectorAll('[data-qty-step]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wrap = btn.parentElement;
          var input = wrap ? wrap.querySelector('.cartpg__qtyinput') : null;
          if (!input) return;
          var next = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10);
          input.value = next < 0 ? 0 : next;
          form.submit();
        });
      });

      Array.prototype.slice.call(form.querySelectorAll('.cartpg__qtyinput')).forEach(function (input) {
        input.addEventListener('change', function () {
          if ((parseInt(input.value, 10) || 0) < 0) input.value = 0;
          form.submit();
        });
      });
    }

    Array.prototype.slice.call(document.querySelectorAll('[data-cart-form]')).forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function init(scope) {
      var dataEl = scope.querySelector('[data-pdp-variants]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var selects = Array.prototype.slice.call(scope.querySelectorAll('.pdp__optselect'));
      var idInput = scope.querySelector('[data-pdp-id]');
      var priceEl = scope.querySelector('[data-pdp-price]');
      var wasEl = scope.querySelector('[data-pdp-was]');
      var saveEl = scope.querySelector('[data-pdp-save]');
      var skuEl = scope.querySelector('[data-pdp-sku]');
      var addBtn = scope.querySelector('[data-pdp-add]');
      var addText = scope.querySelector('[data-pdp-addtext]');
      var stageImgs = Array.prototype.slice.call(scope.querySelectorAll('.pdp__stageimg'));
      var thumbs = Array.prototype.slice.call(scope.querySelectorAll('.pdp__thumb'));

      function chosen() {
        return selects.map(function (s) { return s.value; });
      }

      function match(values) {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < values.length; j++) {
            if (variants[i].o[j] !== values[j]) { ok = false; break; }
          }
          if (ok) return variants[i];
        }
        return null;
      }

      /* Flag option values that can't be reached given the other current choices. */
      function markAvailability() {
        var values = chosen();
        selects.forEach(function (sel, idx) {
          Array.prototype.slice.call(sel.options).forEach(function (opt) {
            if (!opt.dataset.label) opt.dataset.label = opt.textContent.trim();
            var probe = values.slice();
            probe[idx] = opt.value;
            var v = match(probe);
            var reachable = !!(v && v.available);
            opt.dataset.soldOut = reachable ? 'false' : 'true';
            opt.textContent = reachable ? opt.dataset.label : opt.dataset.label + ' — Unavailable';
          });
        });
      }

      function showMedia(id) {
        if (!id) return;
        var found = false;
        stageImgs.forEach(function (img) {
          var on = String(img.dataset.mediaId) === String(id);
          img.classList.toggle('is-active', on);
          if (on) found = true;
        });
        if (found) {
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', String(t.dataset.mediaTarget) === String(id));
          });
        }
      }

      function update() {
        var v = match(chosen());
        markAvailability();

        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = 'Unavailable';
          return;
        }

        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.textContent = v.price;
          priceEl.classList.toggle('pdp__price--sale', v.raw_cap > v.raw_price);
        }
        if (wasEl) {
          if (v.raw_cap > v.raw_price) { wasEl.textContent = v.cap; wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
        if (saveEl) {
          if (v.raw_cap > v.raw_price) { saveEl.textContent = 'Save ' + v.save; saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
        if (skuEl) {
          skuEl.textContent = v.sku || '';
          if (skuEl.parentElement) skuEl.parentElement.hidden = !v.sku;
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addText) addText.textContent = v.available ? 'Add to Cart' : 'Sold Out';

        showMedia(v.media);

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.dataset.mediaTarget); });
      });

      Array.prototype.slice.call(scope.querySelectorAll('[data-qty-step]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = scope.querySelector('.pdp__qtyinput');
          if (!input) return;
          var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10);
          input.value = next < 1 ? 1 : next;
        });
      });

      if (selects.length) markAvailability();
    }

    Array.prototype.slice.call(document.querySelectorAll('.pdp')).forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-roster"] && !Shopify.designMode) return;
  try {
    
  /*
   * Stylist work previews, backed by each stylist's Instagram.
   *
   * 1. Fills the empty "Work preview" tiles on each card. Manually uploaded
   *    previews always win — only placeholder slots get filled — so the owner
   *    can curate a strip and the feed will not overwrite it.
   * 2. Opens a gallery modal (card on the left, large image on the right) when
   *    a tile or "View more" is clicked.
   *
   * If the API is unreachable the placeholders stay exactly as they render
   * server-side and "View more" keeps its original link, so nothing breaks.
   * One request covers every tier on the page.
   */
  (function () {
    if (window.__tmRosterIgLoaded) return;
    window.__tmRosterIgLoaded = true;

    var PROFILES = {};   /* handle -> profile payload */
    var API = '';
    var modal = null, stageImg = null, stageCount = null,
        galGrid = null, lastFocus = null;
    var current = { handle: '', index: 0 };

    /* The gallery wants the full-size image; the card strip only needs a thumb. */
    function fullSrc(post) {
      if (post.image && API) return API + '/image?u=' + encodeURIComponent(post.image);
      return post.proxy || post.thumb || post.image || '';
    }
    function thumbSrc(post) {
      return post.proxy || post.thumb || post.image || '';
    }

    function buildModal() {
      modal = document.createElement('div');
      modal.className = 'tmgal';
      modal.setAttribute('hidden', '');
      modal.innerHTML =
        '<div class="tmgal__backdrop" data-close></div>' +
        '<div class="tmgal__panel" role="dialog" aria-modal="true" aria-label="Stylist work gallery">' +
          '<button class="tmgal__close" type="button" data-close aria-label="Close gallery">X</button>' +
          '<div class="tmgal__row">' +
            '<div class="tmgal__col">' +
              '<div class="tmgal__photo"><img alt="" data-gal-photo></div>' +
              '<h2 class="tmgal__name" data-gal-name></h2>' +
              '<p class="tmgal__meta"><span class="tmgal__role" data-gal-role></span></p>' +
              '<p class="tmgal__bio" data-gal-bio></p>' +
              '<div class="tmgal__gallery">' +
                '<p class="tmgal__label">WORK PREVIEW</p>' +
                '<div class="tmgal__tiles" data-gal-tiles></div>' +
              '</div>' +
            '</div>' +
            '<div class="tmgal__stage">' +
              '<img class="tmgal__img" alt="" data-gal-img>' +
              '<div class="tmgal__stagebar">' +
                '<button class="tmgal__nav" type="button" data-prev aria-label="Previous">&larr;</button>' +
                '<span class="tmgal__count" data-gal-count></span>' +
                '<button class="tmgal__nav" type="button" data-next aria-label="Next">&rarr;</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modal);

      stageImg = modal.querySelector('[data-gal-img]');
      stageCount = modal.querySelector('[data-gal-count]');
      galGrid = modal.querySelector('[data-gal-tiles]');

      modal.addEventListener('click', function (e) {
        if (e.target.hasAttribute && e.target.hasAttribute('data-close')) close();
      });
      modal.querySelector('[data-prev]').addEventListener('click', function () { step(-1); });
      modal.querySelector('[data-next]').addEventListener('click', function () { step(1); });
      document.addEventListener('keydown', function (e) {
        if (!modal || modal.hasAttribute('hidden')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
      });
    }

    function show(i) {
      var profile = PROFILES[current.handle];
      if (!profile || !profile.posts.length) return;
      var n = profile.posts.length;
      current.index = ((i % n) + n) % n;
      var post = profile.posts[current.index];

      stageImg.src = fullSrc(post);
      stageImg.alt = post.caption || 'Work by ' + (profile.fullName || profile.username);
      stageCount.textContent = (current.index + 1) + ' / ' + n;

      Array.prototype.slice.call(galGrid ? galGrid.querySelectorAll('.tmgal__tile') : []).forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === current.index);
      });
    }
    function step(d) { show(current.index + d); }

    function open(card, handle, index) {
      var profile = PROFILES[handle];
      if (!profile || !profile.posts.length) return;
      if (!modal) buildModal();

      lastFocus = document.activeElement;
      current.handle = handle;

      /* Built from the card's data rather than cloned: the panel is white in
         every tier, while a cloned Junior card would drag its dark styling in. */
      function txt(sel) {
        var el = card.querySelector(sel);
        return el ? el.textContent.trim() : '';
      }
      var photo = card.querySelector('.tmcard__img, .tmcard__media img');
      var photoEl = modal.querySelector('[data-gal-photo]');
      if (photo) {
        photoEl.src = photo.currentSrc || photo.src;
        photoEl.removeAttribute('hidden');
      } else {
        photoEl.setAttribute('hidden', '');
      }
      photoEl.alt = txt('.tmcard__name');

      modal.querySelector('[data-gal-name]').textContent = txt('.tmcard__name');
      modal.querySelector('[data-gal-role]').textContent = txt('.tmcard__role');
      modal.querySelector('[data-gal-bio]').textContent = txt('.tmcard__bio');

      galGrid.innerHTML = '';
      profile.posts.forEach(function (post, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tmgal__tile';
        b.setAttribute('aria-label', 'Show image ' + (idx + 1));
        var im = document.createElement('img');
        im.src = thumbSrc(post);
        im.alt = '';
        im.loading = 'lazy';
        b.appendChild(im);
        b.addEventListener('click', function () { show(idx); });
        galGrid.appendChild(b);
      });

      modal.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      show(index || 0);
      modal.querySelector('.tmgal__close').focus();
    }

    function close() {
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
      stageImg.removeAttribute('src');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function run() {
      var sections = Array.prototype.slice.call(document.querySelectorAll('.tmroster[data-ig-api]'));
      if (!sections.length) return;

      var cards = [];
      sections.forEach(function (sec) {
        var endpoint = sec.getAttribute('data-ig-api');
        if (!endpoint) return;
        API = API || endpoint;
        Array.prototype.slice.call(sec.querySelectorAll('.tmcard[data-ig]')).forEach(function (card) {
          cards.push(card);
        });
      });
      if (!API || !cards.length) return;

      var handles = [];
      cards.forEach(function (c) {
        var h = (c.getAttribute('data-ig') || '').trim().toLowerCase();
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
      if (!handles.length) return;

      var url = API + (API.indexOf('?') === -1 ? '?' : '&') + 'users=' + encodeURIComponent(handles.join(','));

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.profiles) return;
          PROFILES = data.profiles;

          cards.forEach(function (card) {
            var handle = (card.getAttribute('data-ig') || '').trim().toLowerCase();
            var profile = PROFILES[handle];
            if (!profile || !profile.posts || !profile.posts.length) return;

            var nameEl = card.querySelector('.tmcard__name');
            var who = nameEl ? nameEl.textContent.trim() : handle;
            var slots = Array.prototype.slice.call(card.querySelectorAll('[data-slot]'));

            slots.forEach(function (slot, i) {
              var post = profile.posts[i];
              if (!post) return;
              var src = thumbSrc(post);
              if (!src) return;

              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'tmcard__thumb tmcard__thumb-btn';
              btn.setAttribute('aria-label', 'Open gallery — ' + who);

              var img = document.createElement('img');
              img.loading = 'lazy';
              img.decoding = 'async';
              img.src = src;
              img.alt = who + ' — recent work on Instagram';
              /* A single broken image restores its placeholder rather than showing a broken icon. */
              img.addEventListener('error', function () {
                if (btn.parentNode) btn.parentNode.replaceChild(slot, btn);
              });

              btn.appendChild(img);
              btn.addEventListener('click', function (e) { e.stopPropagation(); open(card, handle, i); });
              slot.parentNode.replaceChild(btn, slot);
            });

            /* The whole card opens the gallery. */
            card.classList.add('tmcard--clickable');
            card.addEventListener('click', function (e) {
              if (e.target.closest && e.target.closest('[data-book]')) return;
              e.preventDefault();
              open(card, handle, 0);
            });
          });
        })
        .catch(function () { /* leave placeholders and the original link in place */ });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
